import { TelaAfetadaPelaMutacao } from '../../dominio/assistente.interface'
import { normalizarRota } from './nomeDeTela'

/**
 * R6 — decidir se a tela que a pessoa está vendo é a que a mutação envelheceu.
 *
 * O achado: a confirmação respondeu "Feriado criado" e `/#/holidays` seguiu
 * mostrando o total antigo. Não havia nada a esperar — a gravação é síncrona.
 * A tabela é que fora renderizada uma vez, no começo da sessão, e ninguém
 * mandou perguntar de novo.
 *
 * O que este módulo decide é ESTREITO de propósito: revalidar, e só quando a
 * tela aberta é exatamente a tela afetada. Duas coisas que ele deliberadamente
 * NÃO faz:
 *
 * - navegar. Levar a pessoa até a tela a tiraria de onde ela está, e há perfil
 *   que nem alcança a rota;
 * - recarregar o documento. Perder a conversa inteira para atualizar uma
 *   tabela cobra caro demais por um número.
 *
 * A comparação passa por `normalizarRota` porque as duas pontas escrevem o
 * mesmo lugar de formas diferentes: o backend publica `/holidays`, e o host
 * pode ler `#/holidays`, `/holidays/`, ou a rota com query. Nenhuma dessas
 * diferenças muda a tela.
 */
export function telaAbertaFicouVelha (
  telaAfetada: TelaAfetadaPelaMutacao | null | undefined,
  rotaAberta: string | null | undefined
): boolean {
  if (!telaAfetada) return false

  const afetada = normalizarRota(telaAfetada.rota || '')
  const aberta = normalizarRota(rotaAberta || '')
  if (!afetada || !aberta) return false

  return afetada === aberta
}
